/**
 * Smart routers that auto-detect tenant context from hostname.
 * When the user lands on kk.mylms.in or a custom domain, the root + /login
 * routes render the TenantLoginPage automatically — no manual /tenant/:subdomain
 * path needed.
 */
import React from 'react';
import { useAuth } from '../context/AuthContext';
import LandingPage from '../pages/LandingPage';
import LoginPage from '../pages/LoginPage';
import TenantLoginPage from '../pages/TenantLoginPage';
import { SpinnerGap } from '@phosphor-icons/react';

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <SpinnerGap className="w-8 h-8 animate-spin text-primary" />
    </div>
  );
}

/**
 * If tenant detected from hostname → render TenantLoginPage (with subdomain forced via prop)
 * Otherwise → render platform LandingPage / LoginPage.
 */
export function HostAwareRoot() {
  const { tenantInfo, hostTenantChecked } = useAuth();
  if (!hostTenantChecked) return <LoadingScreen />;
  if (tenantInfo?.subdomain && (tenantInfo.source === 'subdomain' || tenantInfo.source === 'custom_domain')) {
    return <TenantLoginPage subdomainOverride={tenantInfo.subdomain} />;
  }
  return <LandingPage />;
}

export function HostAwareLogin() {
  const { tenantInfo, hostTenantChecked } = useAuth();
  if (!hostTenantChecked) return <LoadingScreen />;
  if (tenantInfo?.subdomain && (tenantInfo.source === 'subdomain' || tenantInfo.source === 'custom_domain')) {
    return <TenantLoginPage subdomainOverride={tenantInfo.subdomain} />;
  }
  return <LoginPage />;
}
